import { Price, PriceList, Store } from 'src/types';
import {
  CurrentCampaign,
  IFilterState,
  ProductPriceType,
} from 'src/areas/product/types';
import RatingHelper from '@prisjakt/ui-rating/src/rating-helper';
import { Rating } from 'components/rating/src/types';
import { Offer } from '../price-row/types';

export const getFilter = (prices?: PriceList) => {
  const initialFilter = {
    hasInternationalPrices: false,
    hasUsedProducts: false,
    hasNotInMintCondition: false,
    hasPickupOnly: false,
    hasUnavailable: false,
    hasFilter: false,
  };
  if (!prices || !prices.nodes) {
    return initialFilter;
  }

  const hasInternationalPrices = prices.nodes.some(
    p => p && p.store && p.store.market !== 'primary'
  );
  const hasUsedProducts = prices.nodes.some(
    p => p && p.type === ProductPriceType.USED_PRODUCT
  );
  const hasNotInMintCondition = prices.nodes.some(
    p => p && p.type === ProductPriceType.NOT_IN_MINT_CONDITION
  );
  const hasPickupOnly = prices.nodes.some(
    p => p && p.type === ProductPriceType.PICKUP_ONLY
  );
  const hasUnavailable = prices.nodes.some(
    p => p && p.type === ProductPriceType.UNAVAILABLE
  );

  return {
    hasInternationalPrices,
    hasUsedProducts,
    hasNotInMintCondition,
    hasPickupOnly,
    hasUnavailable,
  };
};

export const getValidPriceType = (type?: string | null) => {
  if (
    !type ||
    !Object.values(ProductPriceType).includes(type as ProductPriceType)
  )
    return null;

  return type as ProductPriceType;
};

export const getStoreRating = (store?: Store | null): Rating | undefined => {
  return store?.userReviewSummary?.rating
    ? RatingHelper.convert(store.userReviewSummary.rating, 1)
    : undefined;
};

export const getCampaignByOfferId = (
  offerId?: string | null,
  campaign?: CurrentCampaign | null
) => {
  return campaign?.price &&
    campaign?.media &&
    campaign?.name &&
    offerId === campaign.price.id
    ? campaign
    : null;
};

export function createOfferFromPriceItem(
  item: Price,
  filters?: IFilterState
): Offer {
  return {
    name: item.name,
    price: item.price,
    offerPrices: item.offerPrices,
    priceId: item.id,
    priceType: getValidPriceType(item.type),
    deliveryOptions: item.deliveryOptions ?? [],
    store: item.store,
    featured: Boolean(item.store?.featured),
    storeInfo:
      item.store && item.store.providedByStore
        ? item.store.providedByStore.generalInformation
        : null,
    rating: getStoreRating(item.store),
    stock: item.stock,
    externalUri: item.externalUri,
    alternativePrices: item.alternativePrices,
    authorizedDealer: Boolean(item.authorizedDealer),
    isInternationalPrice: Boolean(
      filters?.showInternational &&
        item.store &&
        item.store.market === 'secondary'
    ),
    shipping: item.shipping,
  };
}
